import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const UserManagementPanel = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState('all');
  const [selectedRole, setSelectedRole] = useState('all');
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [showAddUserModal, setShowAddUserModal] = useState(false);

  const users = [
  {
    id: 1,
    name: "Sarah Chen",
    email: "sarah.chen@modularflow.com",
    role: "Production Manager",
    department: "Assembly Line 3",
    status: "active",
    lastLogin: new Date(Date.now() - 2 * 3600000),
    permissions: ["workflow_design", "resource_allocation", "timeline_management"],
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1839f83d3-1763293825256.png",
    avatarAlt: "Professional headshot of Asian woman with shoulder-length black hair wearing navy blazer"
  },
  {
    id: 2,
    name: "Marcus Rodriguez",
    email: "marcus.rodriguez@modularflow.com",
    role: "Factory Supervisor",
    department: "Quality Control",
    status: "active",
    lastLogin: new Date(Date.now() - 30 * 60000),
    permissions: ["status_tracking", "quality_inspection"],
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1bb37aa02-1763293838410.png",
    avatarAlt: "Professional headshot of Hispanic man with short dark hair and beard wearing gray suit"
  },
  {
    id: 3,
    name: "Emily Watson",
    email: "emily.watson@modularflow.com",
    role: "Operations Planner",
    department: "Planning",
    status: "active",
    lastLogin: new Date(Date.now() - 5 * 3600000),
    permissions: ["resource_allocation", "scheduling", "reporting"],
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1efea8232-1763295833460.png",
    avatarAlt: "Professional headshot of Caucasian woman with blonde hair in bun wearing white blouse"
  },
  {
    id: 4,
    name: "James Park",
    email: "james.park@modularflow.com",
    role: "Shop Floor Worker",
    department: "Assembly Line 1",
    status: "active",
    lastLogin: new Date(Date.now() - 15 * 60000),
    permissions: ["task_updates"],
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_198800f56-1763301015535.png",
    avatarAlt: "Professional headshot of Asian man with short black hair wearing blue work uniform"
  },
  {
    id: 5,
    name: "Linda Martinez",
    email: "linda.martinez@modularflow.com",
    role: "Plant Director",
    department: "Executive",
    status: "active",
    lastLogin: new Date(Date.now() - 60 * 60000),
    permissions: ["full_access", "system_admin"],
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1bfb5f0cf-1763294330031.png",
    avatarAlt: "Professional headshot of Hispanic woman with long dark hair wearing black business suit"
  },
  {
    id: 6,
    name: "Robert Kim",
    email: "robert.kim@modularflow.com",
    role: "Quality Control Inspector",
    department: "Quality Control",
    status: "inactive",
    lastLogin: new Date(Date.now() - 48 * 3600000),
    permissions: ["quality_inspection", "checkpoint_verification"],
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_14096d2d9-1763296486815.png",
    avatarAlt: "Professional headshot of Asian man with glasses and short black hair wearing white lab coat"
  }];


  const departmentOptions = [
  { value: 'all', label: 'All Departments' },
  { value: 'assembly_line_1', label: 'Assembly Line 1' },
  { value: 'assembly_line_3', label: 'Assembly Line 3' },
  { value: 'quality_control', label: 'Quality Control' },
  { value: 'planning', label: 'Planning' },
  { value: 'executive', label: 'Executive' }];


  const roleOptions = [
  { value: 'all', label: 'All Roles' },
  { value: 'production_manager', label: 'Production Manager' },
  { value: 'factory_supervisor', label: 'Factory Supervisor' },
  { value: 'operations_planner', label: 'Operations Planner' },
  { value: 'shop_floor_worker', label: 'Shop Floor Worker' },
  { value: 'plant_director', label: 'Plant Director' },
  { value: 'quality_inspector', label: 'Quality Control Inspector' }];


  const filteredUsers = users?.filter((user) => {
    const matchesSearch = user?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    user?.email?.toLowerCase()?.includes(searchQuery?.toLowerCase());
    const matchesDepartment = selectedDepartment === 'all' || user?.department === selectedDepartment;
    const matchesRole = selectedRole === 'all' || user?.role === selectedRole;
    return matchesSearch && matchesDepartment && matchesRole;
  });

  const handleSelectUser = (userId) => {
    setSelectedUsers((prev) =>
    prev?.includes(userId) ?
    prev?.filter((id) => id !== userId) :
    [...prev, userId]
    );
  };

  const handleSelectAll = () => {
    if (selectedUsers?.length === filteredUsers?.length) {
      setSelectedUsers([]);
    } else {
      setSelectedUsers(filteredUsers?.map((u) => u?.id));
    }
  };

  const formatLastLogin = (date) => {
    const now = new Date();
    const diff = Math.floor((now - date) / 60000);
    if (diff < 60) return `${diff}m ago`;
    if (diff < 1440) return `${Math.floor(diff / 60)}h ago`;
    return `${Math.floor(diff / 1440)}d ago`;
  };

  return (
    <div className="space-y-4 md:space-y-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-4">
          <Input
            type="search"
            placeholder="Search users..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e?.target?.value)} />

          <Select
            options={departmentOptions}
            value={selectedDepartment}
            onChange={setSelectedDepartment}
            placeholder="Filter by department" />

          <Select
            options={roleOptions}
            value={selectedRole}
            onChange={setSelectedRole}
            placeholder="Filter by role" />

        </div>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            iconName="Download"
            iconPosition="left"
            onClick={() => console.log('Export users')}>

            Export
          </Button>
          <Button
            variant="default"
            iconName="UserPlus"
            iconPosition="left"
            onClick={() => setShowAddUserModal(true)}>

            Add User
          </Button>
        </div>
      </div>
      {selectedUsers?.length > 0 &&
      <div className="flex items-center justify-between px-4 md:px-6 py-3 bg-primary/10 rounded-xl border border-primary/20">
          <span className="text-sm font-medium text-foreground">
            {selectedUsers?.length} user{selectedUsers?.length > 1 ? 's' : ''} selected
          </span>
          <div className="flex items-center gap-2">
            <Button variant="outline" size="sm" iconName="Mail">
              Send Email
            </Button>
            <Button variant="outline" size="sm" iconName="Lock">
              Manage Permissions
            </Button>
            <Button variant="destructive" size="sm" iconName="Trash2">
              Deactivate
            </Button>
          </div>
        </div>
      }
      <div className="bg-card rounded-xl border border-border overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-muted border-b border-border">
              <tr>
                <th className="px-4 md:px-6 py-3 text-left">
                  <Checkbox
                    checked={selectedUsers?.length === filteredUsers?.length && filteredUsers?.length > 0}
                    onChange={handleSelectAll} />

                </th>
                <th className="px-4 md:px-6 py-3 text-left text-sm font-semibold text-foreground">User</th>
                <th className="px-4 md:px-6 py-3 text-left text-sm font-semibold text-foreground hidden md:table-cell">Role</th>
                <th className="px-4 md:px-6 py-3 text-left text-sm font-semibold text-foreground hidden lg:table-cell">Department</th>
                <th className="px-4 md:px-6 py-3 text-left text-sm font-semibold text-foreground hidden lg:table-cell">Last Login</th>
                <th className="px-4 md:px-6 py-3 text-left text-sm font-semibold text-foreground">Status</th>
                <th className="px-4 md:px-6 py-3 text-right text-sm font-semibold text-foreground">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {filteredUsers?.map((user) =>
              <tr key={user?.id} className="hover:bg-muted/50 transition-colors duration-250">
                  <td className="px-4 md:px-6 py-4">
                    <Checkbox
                    checked={selectedUsers?.includes(user?.id)}
                    onChange={() => handleSelectUser(user?.id)} />

                  </td>
                  <td className="px-4 md:px-6 py-4">
                    <div className="flex items-center gap-3">
                      <img
                      src={user?.avatar}
                      alt={user?.avatarAlt}
                      className="w-10 h-10 rounded-full object-cover" />

                      <div className="min-w-0">
                        <p className="text-sm font-medium text-foreground truncate">{user?.name}</p>
                        <p className="caption text-muted-foreground truncate">{user?.email}</p>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 md:px-6 py-4 hidden md:table-cell">
                    <span className="text-sm text-foreground">{user?.role}</span>
                  </td>
                  <td className="px-4 md:px-6 py-4 hidden lg:table-cell">
                    <span className="text-sm text-muted-foreground">{user?.department}</span>
                  </td>
                  <td className="px-4 md:px-6 py-4 hidden lg:table-cell">
                    <span className="caption text-muted-foreground">{formatLastLogin(user?.lastLogin)}</span>
                  </td>
                  <td className="px-4 md:px-6 py-4">
                    <span className={`inline-flex items-center px-2 py-1 rounded-lg text-xs font-medium ${
                  user?.status === 'active' ? 'bg-success/10 text-success' : 'bg-muted text-muted-foreground'}`
                  }>
                      {user?.status === 'active' ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td className="px-4 md:px-6 py-4">
                    <div className="flex items-center justify-end gap-2">
                      <button
                      className="p-2 hover:bg-muted rounded-lg transition-colors duration-250"
                      onClick={() => console.log('Edit user', user?.id)}
                      aria-label="Edit user">

                        <Icon name="Edit2" size={16} />
                      </button>
                      <button
                      className="p-2 hover:bg-muted rounded-lg transition-colors duration-250"
                      onClick={() => console.log('View permissions', user?.id)}
                      aria-label="View permissions">

                        <Icon name="Shield" size={16} />
                      </button>
                      <button
                      className="p-2 hover:bg-destructive/10 text-destructive rounded-lg transition-colors duration-250"
                      onClick={() => console.log('Delete user', user?.id)}
                      aria-label="Delete user">

                        <Icon name="Trash2" size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 px-4 md:px-6 py-4 bg-card rounded-xl border border-border">
        <span className="caption text-muted-foreground">
          Showing {filteredUsers?.length} of {users?.length} users
        </span>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" iconName="ChevronLeft" disabled>
            Previous
          </Button>
          <Button variant="outline" size="sm" iconName="ChevronRight">
            Next
          </Button>
        </div>
      </div>
    </div>);

};

export default UserManagementPanel;